import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { MessageSeverity, RatelistStatus } from "@sinch/core/entities/serverEnums";
import { MdsOutbox } from "@sinch/icons";
import { parseMutationErrorsFromData } from "@sinch/utils/apollo";
import { useSnackbar } from "notistack";
import { propEq } from "ramda";
import { isNotNilOrEmpty } from "ramda-adjunct";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { MdsIcon } from "@sinch/components";
import { useRatelist } from "@sinch/components/application/Rate/useRatelist";
import { ConfirmDialogWrapper } from "@sinch/components/ConfirmDialogWrapper/ConfirmDialogWrapper";

export const RestoreMenuItem = ({ id, onPerformedAction }: { id: string; onPerformedAction: () => void }) => {
  const { t } = useTranslation(["common", "draft"]);

  const { enqueueSnackbar } = useSnackbar();
  const { setStatus } = useRatelist();

  const handleConfirmRestore = useCallback(async () => {
    try {
      const response = await setStatus({ variables: { ratelistId: id, status: RatelistStatus.Active } });
      if (response.data?.changeRatelistStatus.result) {
        onPerformedAction();
        enqueueSnackbar(t("restoredSuccessfully"), { variant: "success" });
      } else {
        const firstMessage = parseMutationErrorsFromData(response).find((message) =>
          propEq("severity", MessageSeverity.Error)(message)
        )?.message;
        if (isNotNilOrEmpty(firstMessage)) {
          enqueueSnackbar(firstMessage, { variant: "error" });
        } else {
          enqueueSnackbar(t("ratelistError"), { variant: "error" });
        }
      }
    } catch {
      enqueueSnackbar(t("ratelistError"), { variant: "error" });
    }
  }, [setStatus, id, onPerformedAction, enqueueSnackbar, t]);
  return (
    <ConfirmDialogWrapper
      content={t("RateBuilder.confirmRestore")}
      label={t("RateBuilder.confirmRestoreTitle")}
      onConfirm={handleConfirmRestore}
      render={({ openConfirmation }) => (
        <MenuItem color="success" onClick={openConfirmation}>
          <ListItemIcon>
            <MdsIcon color="success" icon={MdsOutbox} />
          </ListItemIcon>
          <ListItemText sx={{ color: "success.main" }}>{t("restore")}</ListItemText>
        </MenuItem>
      )}
    />
  );
};
